// Generates a random color that is not too dark and not too close to an array of existing colors
export function generateRandomColor(existingColors: string[]): string {
    let color: string;
    do {
        color = "#" + Math.floor(Math.random() * 16777215).toString(16);
    } while (
        isTooDark(color) ||
        isTooCloseToExistingColors(color, existingColors)
    );
    return color;
}

function extractRBG(color: string): { r: number; g: number; b: number } {
    const rgb = parseInt(color.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    return { r, g, b };
}

function isTooDark(color: string): boolean {
    const { r, g, b } = extractRBG(color);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128; // Adjust the threshold as needed
}

function isTooCloseToExistingColors(
    color: string,
    existingColors: string[]
): boolean {
    const { r, g, b } = extractRBG(color);

    for (const existingColor of existingColors) {
        const {
            r: existingR,
            g: existingG,
            b: existingB
        } = extractRBG(existingColor);

        const distance = Math.sqrt(
            Math.pow(r - existingR, 2) +
                Math.pow(g - existingG, 2) +
                Math.pow(b - existingB, 2)
        );

        if (distance < 100) {
            return true;
        }
    }
    return false;
}
